import React from 'react';
import PropTypes from 'prop-types';


import styles from './PopupNew.scss';

import CloseButton from "./CloseButton";
import {__t} from '../lang/text-resource';


class PopupNew extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isVisible: props.isVisible
		};
	}

	close = () => {
		const state = this.state;
		state.isVisible = false;
		this.setState({...state}, () => {

			if (typeof this.props.closeCallBack === 'function') {
				this.props.closeCallBack();
			}
		});
	};

	show = () => {
		const state = this.state;
		state.isVisible = true;
		this.setState({...state});
	};

	onEsc = (event) => {
		if (this.state.isVisible) {
			if (event.keyCode === 27) {
				this.close();
			}
		}
	};

	componentDidMount() {
		document.addEventListener('keydown', this.onEsc, false);
	}

	componentWillUnmount() {
		document.body.style.overflow = "auto";
		document.removeEventListener('keydown', this.onEsc, false);
	}


	render() {
		document.body.style.overflow = "auto";
		if (this.state.isVisible) {
			document.body.style.overflow = "hidden"
		} else {
			return null;
		}

		const classNames = [styles.container];
		if (this.props.darker) {
			classNames.push(styles.darker);
		}

		if (this.props.whiteMode) {
			classNames.push(styles.whiteMode);
		}

		if (this.props.bigger) {
			classNames.push(styles.bigger);
		}

		if (this.props.alignItemsStart) {
			classNames.push(styles.alignItemsStart);
		}

		return (
		  <div>
			  <div className={classNames.join(' ')}>
				  <div>
					  <div className={styles.closeButton}>
						  <CloseButton onClick={this.close} altText={__t("Close")}/>
					  </div>
					  {this.props.children}
				  </div>
			  </div>
		  </div>
		);
	}
}

PopupNew.propTypes = {
	name: PropTypes.string.isRequired,
	isVisible: PropTypes.bool.isRequired,
	children: PropTypes.node,
	darker: PropTypes.bool,
	bigger: PropTypes.bool,
	alignItemsStart: PropTypes.bool,
	whiteMode: PropTypes.bool,
	closeCallBack: PropTypes.func,
};

export default PopupNew;